<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-spinner></app-spinner>

<!-- Load translation for APP: -->
<router-outlet *transloco="let t"></router-outlet>
